export const UDesignCloudAppMinimumRequirements = {
    title: "Minimum System Requirements",
    requirements: [
      {
        label: "Browser",
        content: "Latest version of Chrome (64 or 32 bit) on Windows 10/11 and Mac OS (Laptops or Desktops)"
      },
      {
        label: "Processor",
        subItems: [
          {
            label: "Minimum",
            content: [
              "10th Generation i7 for Mac or Windows Computers",
              "M1 or faster processor for MacOS"
            ]
          },
          {
            label: "Recommended",
            content: [
              "10th Generation i7 for Mac or Windows Computers",
              "M2 or faster processor for MacOS"
            ]
          }
        ]
      },
      {
        label: "RAM",
        content: "16 GB"
      },
      {
        label: "Internet bandwidth",
        content: "Minimum of 20 mbps for upload and 20 mbps for download"
      },
      {
        label: "Screen resolutions",
        content: "1920 x 1080 px and up"
      }
    ]
  };